// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Yf3F","detailsBorder":"styles_detailsBorder__1tF-M"};